// Ce fichier est généré automatiquement par scripts/generate-service-registers.js
// Ne pas modifier manuellement - vos changements seront écrasés
// Pour régénérer : pnpm run generate:service-registers

// ================================
// IMPORTS DES SERVICES
// ================================
import { AccessService } from "./access.service"
import { AddressService } from "./address.service"
import { AuthService } from "./auth.service"
import { BatiService } from "./bati.service"
import { BuildingService } from "./building.service"
import { CompanyService } from "./company.service"
import { ConfigService } from "./config.service"
import { ConsentService } from "./consent.service"
import { ConsentRequestService } from "./consentrequest.service"
import { EnedisService } from "./enedis.service"
import { EnergyContractService } from "./energy-contract.service"
import { FolderService } from "./folder.service"
import { GrdfService } from "./grdf.service"
import { RapportService } from "./rapport.service"
import { SearchService } from "./search.service"
import { SourceService } from "./source.service"
import { SupportService } from "./support.service"
import { TaskService } from "./task.service"
import { UserService } from "./user.service"

// ================================
// EXPORTS DES SERVICES
// ================================
export * from "./access.service"
export * from "./address.service"
export * from "./auth.service"
export * from "./bati.service"
export * from "./building.service"
export * from "./company.service"
export * from "./config.service"
export * from "./consent.service"
export * from "./consentrequest.service"
export * from "./enedis.service"
export * from "./energy-contract.service"
export * from "./folder.service"
export * from "./grdf.service"
export * from "./rapport.service"
export * from "./search.service"
export * from "./source.service"
export * from "./support.service"
export * from "./task.service"
export * from "./user.service"

// ================================
// REGISTRY DES SERVICES
// ================================
export const coreServiceRegistry = {
    access: new AccessService(),
    address: new AddressService(),
    auth: new AuthService(),
    bati: new BatiService(),
    building: new BuildingService(),
    company: new CompanyService(),
    config: new ConfigService(),
    consent: new ConsentService(),
    consentRequest: new ConsentRequestService(),
    enedis: new EnedisService(),
    energyContract: new EnergyContractService(),
    folder: new FolderService(),
    grdf: new GrdfService(),
    rapport: new RapportService(),
    search: new SearchService(),
    source: new SourceService(),
    support: new SupportService(),
    task: new TaskService(),
    user: new UserService(),
} as const

// ================================
// TYPES DU REGISTRY
// ================================
export type CoreServiceRegistry = typeof coreServiceRegistry
